// Commercial configuration. Change prices here only.
export const BASE_ADDRESS_PRICE = 0.53;
export const MIN_CAMPAIGN_QUANTITY = 500;
export const QUICK_QUANTITIES = [2500, 5000, 10000];

// null = not yet priced; confirmed by the Print team.
export const FORMAT_PRICING = { letter: null, postcard: null, unsure: null };
export const SERVICE_PRICING = {};

const round2 = (n) => Math.round(n * 100) / 100;

export function calculateCampaignPrice(quantity, configuration = {}) {
  const pricePerAddress = configuration.pricePerAddress ?? BASE_ADDRESS_PRICE;
  const qty = Math.max(0, Math.round(quantity || 0));
  const baseCost = round2(qty * pricePerAddress);
  const formatUnit = configuration.format ? FORMAT_PRICING[configuration.format] : null;
  const services = configuration.services || [];
  const pricedServices = services.filter((s) => SERVICE_PRICING[s] != null);
  const extras = round2(
    (formatUnit ? formatUnit * qty : 0) + pricedServices.reduce((acc, s) => acc + SERVICE_PRICING[s] * qty, 0)
  );
  const pendingItems = [
    ...(configuration.format && formatUnit == null ? ["format"] : []),
    ...services.filter((s) => SERVICE_PRICING[s] == null),
  ];
  return { quantity: qty, pricePerAddress, baseCost, extras, estimatedTotal: round2(baseCost + extras), pendingItems };
}

export const formatGBP = (value) =>
  new Intl.NumberFormat("en-GB", {
    style: "currency",
    currency: "GBP",
    minimumFractionDigits: Number.isInteger(value) ? 0 : 2,
    maximumFractionDigits: 2,
  }).format(value);

export const formatPence = (value) => `£${value.toFixed(2)}`;
